<template>
    <aside class="sidenav" v-bind:class="{'sidenav--active': value}">
        <div class="sidenav__brand">
            <router-link to="/" class="sidenav__brand-link">
                <img class="" src="../../assets/logo.svg">
            </router-link>

            <span @click="closeSidebar()">
                <i class="fas fa-times sidenav__brand-close"></i>
            </span>
        </div>
        <div class="row row--align-v-center row--align-h-center">
            <ul class="navList">
                <li class="navList__heading"></li>
                <li>
                    <div class="navList__subheading row row--align-v-center" @click="go('/')">
                        <span class="navList__subheading-icon"><i class="fas fa-home"></i></span> <span class="navList__subheading-title">{{ $t('layout.sidebar.menu.dashboard') }}</span>
                    </div>
                </li>
                <li>
                    <div class="navList__subheading row row--align-v-center" @click="go('/customers')">
                        <span class="navList__subheading-icon"><i class="fas fa-users"></i></span> <span class="navList__subheading-title">{{ $t('layout.sidebar.menu.customers') }}</span>
                    </div>
                </li>
                <li>
                    <div class="navList__subheading row row--align-v-center" @click="go('/calendar')">
                        <span class="navList__subheading-icon"><i class="fas fa-calendar-check"></i></span> <span class="navList__subheading-title">{{ $t('layout.sidebar.menu.calendar') }}</span>
                    </div>
                </li>
                <li class="navList__heading">{{ $t('layout.sidebar.menu.documents')}}</li>
                <li>
                    <div class="navList__subheading row row--align-v-center" @click="go('/interventionreport')">
                        <span class="navList__subheading-icon"><i class="fas fa-file-alt"></i></span> <span class="navList__subheading-title">{{ $t('layout.sidebar.menu.intervention_report') }}</span>
                    </div>
                </li>
                <li>
                    <div class="navList__subheading row row--align-v-center" @click="go('/checksheet')">
                        <span class="navList__subheading-icon"><i class="fas fa-file-alt"></i></span> <span class="navList__subheading-title">{{ $t('layout.sidebar.menu.check_sheet') }}</span>
                    </div>
                </li>
                <li class="navList__heading" v-if="isAdmin">{{ $t('layout.sidebar.menu.admin')}}</li>
                <li v-if="isAdmin">
                    <div class="navList__subheading row row--align-v-center" @click="go('/users')">
                        <span class="navList__subheading-icon"><i class="fas fa-users"></i></span> <span class="navList__subheading-title">{{ $t('layout.sidebar.menu.users') }}</span>
                    </div>
                </li>
            </ul>
        </div>
    </aside>
</template>
<script>
    export default {
        name: 'sidebar-component',
        components: {},
        props: {
            value: {
                required: true
            }
        },
        mounted() {
            this.getProfile();
        },
        data() {
            return {
                isAdmin: false,
            };
        },
        methods: {
            go(link) {
                this.$router.push(link).catch(() => {});
            },
            closeSidebar() {
                this.$emit('input', !this.value);
            },
            getProfile() {
                this.api.get('/profile', null, true)
                    .then((result) => {
                        if(result && result.success) {
                            this.isAdmin = result.data.role.trim().toLocaleUpperCase() == 'ADMIN' ? true : false;
                        }
                    })
                    .finally(() => {
                    })
            },
        }
    }
</script>
